import { FC, useState } from 'react';
import { Paper, Typography } from '@mui/material';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { IEntityContentField } from '../../lib/interfaces/Common';
import { ISubscriptionPlan } from '../../lib/interfaces/SubscriptionPlan';
import { setLoginModalOpen } from '../../redux/reducers/ui/modalsReducer';
import { contentMandatoryFields } from '../Form/form.utils';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import ContentRenderer from '../Smart/Content/ContentRenderer';
import { IOrderDTO } from '../../lib/interfaces/Order';
import { createSubscriptionPaymentSession } from '../../api/apiRequests/payment';
import { SubscriptionStatus } from '../../lib/interfaces/Subscription';
import ConfirmationModal from '../Simple/Modals/ConfirmationModal';
import CtaButton from '../Simple/CtaButtons/CtaButton';

type SubscriptionPlanCardType = {
	subscriptionPlan: ISubscriptionPlan;
};

const SubscriptionPlanCard: FC<SubscriptionPlanCardType> = ({
	subscriptionPlan,
}) => {
	const { t, i18n } = useTranslation();
	const { data: currentUser } = useUserMeQuery();
	const dispatch = useDispatch();
	const currentLanguage: string = i18n.language;
	const { content, id, defaultPrice } = subscriptionPlan;
	const contentFields: IEntityContentField[] = content[currentLanguage];
	const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
	const [storedSubscriptionPlan, setStoredSubscriptionPlan] = useState<
		ISubscriptionPlan | undefined
	>();

	// const userMutation = useMutation<
	// 	Partial<User>,
	// 	AxiosError<any>,
	// 	Partial<User>
	// >((data) => changeSubscriptionPlan(data), {
	// 	onSuccess: () => {
	// 		refetch();
	// 	},
	// });

	const createOrderMutation = useMutation<
		{ url: string },
		AxiosError<any>,
		IOrderDTO
	>((order: IOrderDTO) => createSubscriptionPaymentSession(order));

	const createSubscriptionOrder = () => {
		const order: IOrderDTO = {
			product: subscriptionPlan.productId,
			quantity: 1,
			orderDetails: {},
		};

		createOrderMutation.mutate(order, {
			onSuccess(data) {
				if (data?.url) {
					window.location.href = data.url;
				} else {
					window.location.reload();
				}
			},
		});
	};

	const choosePlan = (subscriptionPlan: ISubscriptionPlan) => {
		if (currentUser) {
			if (currentUser.subscriptionPlanId !== subscriptionPlan.id) {
				// userMutation.mutate({ subscriptionPlan: planId });
				createSubscriptionOrder();
			}
		} else {
			dispatch(setLoginModalOpen(true));
		}
	};

	const checkPlan = (subscriptionPlan: ISubscriptionPlan) => {
		console.log('planId: ', subscriptionPlan);
		console.log('currentUser subs: ', currentUser?.subscriptions);

		console.log(createSubscriptionOrder, dispatch, setLoginModalOpen);
		const currentActive = currentUser?.subscriptions.find(
			(s) => s.status === SubscriptionStatus.ACTIVE,
		);

		console.log(
			currentActive &&
				Number(currentActive.plan.defaultPrice) > 0 &&
				Number(subscriptionPlan.defaultPrice) === 0,
		);
		if (
			currentActive &&
			Number(currentActive.plan.defaultPrice) > 0 &&
			Number(subscriptionPlan.defaultPrice) === 0
		) {
			// DOWNGRADE FLOW
			setOpenConfirmation(true);
			setStoredSubscriptionPlan(subscriptionPlan);
		} else {
			choosePlan(subscriptionPlan);
		}
	};

	const downgradeCallback = () => {
		setOpenConfirmation(false);
		if (storedSubscriptionPlan) {
			choosePlan(storedSubscriptionPlan);
		}
	};

	return (
		<div>
			<Paper elevation={0} className="home-plans__item" style={{ width: '100%' }}>
				<Typography
					variant="h5"
					component="h5"
					sx={{
						fontSize: '25px',
						lineHeight: '144%',
						opacity: 0.5,
						fontWeight: 600,
					}}
				>
					{contentFields.map((field) => {
						if (field.name === `${contentMandatoryFields.NAME}_${currentLanguage}`) {
							return field.content;
						}
					})}
				</Typography>
				<div className="home-plans__item-price">
					<Typography
						variant="h4"
						component="h4"
						sx={{ margin: '15px 0', fontWeight: 600, fontSize: '49px' }}
					>
						${defaultPrice}
						<span className="SubscriptionPlan__item_price-title">/ {t('month')}</span>
					</Typography>
				</div>
				<Typography variant="body1" component="p">
					{contentFields.map((field) => {
						if (
							field.name === `${contentMandatoryFields.CONTENT}_${currentLanguage}`
						) {
							return <ContentRenderer html={field.content} key={field.name} />;
						}
					})}
				</Typography>

				<div className="home-plans__item-button-wrapper">
					{/* <div className="button button-standard home-plans__item-button">
						Subscribe
					</div> */}
					<CtaButton
						variant="contained"
						disableElevation
						disabled={currentUser?.subscriptionPlanId === id}
						color="primary"
						size="large"
						onClick={() => {
							checkPlan(subscriptionPlan);
						}}
					>
						{currentUser?.subscriptionPlanId === id
							? `${t('currentPlan')}`
							: `${t('subscribe')}`}
					</CtaButton>
				</div>
			</Paper>
			{/* <Paper variant="outlined" className="SubscriptionPlan__item">
				<div className="SubscriptionPlan__item_top-part">
					<Typography variant="h5" component="h5">
						{contentFields.map((field) => {
							if (field.name === `${contentMandatoryFields.NAME}_${currentLanguage}`) {
								return <ContentRenderer html={field.content} key={field.name} />;
							}
						})}
					</Typography>
					<Typography
						variant="h4"
						component="h4"
						sx={{ margin: '15px 0', fontWeight: 600 }}
					>
						${defaultPrice}
						<span className="SubscriptionPlan__item_price-title">/{t('month')}</span>
					</Typography>
					<Typography variant="body1" component="p">
						{contentFields.map((field) => {
							if (
								field.name === `${contentMandatoryFields.CONTENT}_${currentLanguage}`
							) {
								return <ContentRenderer html={field.content} key={field.name} />;
							}
						})}
					</Typography>
				</div>
				<Button
					disabled={currentUser?.subscriptionPlanId === id}
					color="primary"
					variant="contained"
					className="SubscriptionPlan__item_button text-elem"
					size="large"
					onClick={() => {
						checkPlan(subscriptionPlan);
					}}
				>
					{currentUser?.subscriptionPlanId === id
						? `${t('currentPlan')}`
						: `${t('subscribe')}`}
				</Button>
			</Paper> */}
			<ConfirmationModal
				open={openConfirmation}
				title="Are you sure?"
				text="By choosing Free plan your paid subscription will be cancelled."
				okText="Ok, proceed"
				okCallback={downgradeCallback}
				cancelCallback={() => setOpenConfirmation(false)}
			/>
		</div>
	);
};

export default SubscriptionPlanCard;
